import { render, staticRenderFns } from "./seguro-para-casa.vue?vue&type=template&id=52fc11a4&"
import script from "./seguro-para-casa.vue?vue&type=script&lang=js&"
export * from "./seguro-para-casa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports